export const TournamentStatus = {
  Upcoming: 10,
  RegStarted: 20,
  RegOver: 30,
  CheckIn: 40,
  GridReady: 50,
  Live: 60,
  Over: 70
};

export const TournamentType = {
  Qual: 10,
  Final: 20
};

export const checkIsUpcoming = status => status === TournamentStatus.Upcoming;
export const checkIsRegStarted = status =>
  status === TournamentStatus.RegStarted;
export const checkIsRegOver = status => status === TournamentStatus.RegOver;
export const checkIsCheckIn = status => status === TournamentStatus.CheckIn;
export const checkIsGridReady = status => status === TournamentStatus.GridReady;
export const checkIsLive = status => status === TournamentStatus.Live;
export const checkIsOver = status => status === TournamentStatus.Over;

export const checkIsNotStarted = status => status < TournamentStatus.Live;
export const checkIsNotEnded = status =>
  status >= TournamentStatus.RegStarted && status < TournamentStatus.Over;

export const TournamentStatusHelper = {
  checkIsUpcoming,
  checkIsRegStarted,
  checkIsRegOver,
  checkIsCheckIn,
  checkIsGridReady,
  checkIsLive,
  checkIsOver,
  checkIsNotStarted,
  checkIsNotEnded
};

export const checkIsFinal = type => type === TournamentType.Final;
